export default __webpack_public_path__ + "static/media/amazon-ecs.29663a686dcc3c3d447806b14ed51b9b.svg";